import React, { useState } from 'react';
import { Switch, View } from 'react-native';
import Modal from 'react-modal';
import {
  Container,
  Title,
  HeaderCart,
  ItemsContainer,
  ButtonContainer,
  TotalPrice,
  TotalContainer,
  TotalTitle,
  InputText,
  InputTextContainer,
  ConfirmContainer,
  CloseButton,
  Label,
  ToggleRow,
  ToggleLabel,
  GroupLabel,
  SubLabel,
} from './styles';
import {
  reset,
  setClientName,
  setAddress,
  setPostalCode,
  setWantsInvoice as setWantsInvoiceAction,
  setDocument,
} from '../../../Store/CartStore';
import { formatCurrency } from '../../../Helpers/currency';
import CustomButton from '../../../Components/CustomButton';
import { ReactComponent as CloseIcon } from '../../../Assets/Images/close.svg';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigation } from '@react-navigation/native';
import { CreateEvent, SendOrder } from '../../../Services/API/store';
import { EVENT_TYPE } from '../../../Services/API/schemas';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { openUrl } from '../../../Helpers/general';

const Checkout = ({ clientModal, setClientModal }) => {
  const cart = useSelector(state => state.cart);
  const { payment } = cart;
  const { store } = useSelector(state => state.general);
  const [modalClientName, setModalClientName] = useState(cart.clientName);
  const [modalClientAddress, setModalClientAddress] = useState(cart.address);
  const [modalClientPostalCode, setModalClientPostalCode] = useState(
    cart.postalCode || '',
  );
  const [wantsInvoice, setWantsInvoice] = useState(!!cart.wantsInvoice);
  const [modalClientDocument, setModalClientDocument] = useState(
    cart.document || '',
  );
  const [modalClientChange, setModalClientChange] = useState(0);
  const navigation = useNavigation();
  const dispatch = useDispatch();
  const getOrderText = () => {
    dispatch(setAddress(modalClientAddress));
    dispatch(setClientName(modalClientName));
    dispatch(setPostalCode(modalClientPostalCode));
    dispatch(setWantsInvoiceAction(wantsInvoice));
    dispatch(setDocument(modalClientDocument));

    if (wantsInvoice && !modalClientDocument.trim()) {
      toast.error('Informe o documento para a factura', {
        position: 'bottom-center',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }

    if (cart?.items?.length <= 0) {
      toast.error('Você não tem itens no carrinho', {
        position: 'bottom-center',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }

    const isBrazil = store?.currency === 'R$';

    var message = 'Pedido realizado utilizando Menu Legal \r\n\r\n';
    message += `Cliente: *${modalClientName}*\r\nEndereço de entrega: *${modalClientAddress}*`;

    if (modalClientPostalCode.trim()) {
      message += `\r\nCódigo postal: *${modalClientPostalCode.trim()}*`;
    }

    message += `\r\nDeseja factura: *${wantsInvoice ? 'Sim' : 'Não'}*`;
    if (wantsInvoice) {
      message += `\r\nDocumento (${isBrazil ? 'CPF ou NIF' : 'NIF'}): *${modalClientDocument.trim()}*`;
    }

    message += `\r\n\r\n`;

    cart.items.forEach(({ quantity, name, price, note }) => {
      message += `${quantity}x ${name ? name : ''}${price.title ? price.title : ''
        } *${formatCurrency(price.value * quantity, store?.currency)}*${note ? '\r\n' + note : ''
        }\r\n\r\n`;
    });

    message += `\r\n\r\nTipo de entrega: *${cart.delivery.name}*`;

    message += `\r\nValor da entrega: *${cart.delivery.display}*`;

    if (store.hasPayment && store.payments.length > 0 && cart.payment) {
      message += `\r\n\r\nForma de pagamento: *${cart.payment.name}*\r\n`;
    }

    message += `Itens: *${formatCurrency(cart.totalItems, store?.currency)}*`;
    message += ` \r\nTOTAL: *${formatCurrency(
      cart.total,
      store?.currency,
    )}*\r\n`;

    if (payment?.hasChange) {
      if (modalClientChange > 0 && modalClientChange < cart.total) {
        toast.error(
          'O valor que irá pagar tem que ser maior que o total para ter troco',
          {
            position: 'top-center',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          },
        );
        return;
      }

      if (modalClientChange > 0 && modalClientChange != cart.total) {
        message += `\r\n*Troco*`;
        message += `\r\nValor que será pago: *${formatCurrency(
          modalClientChange,
          store?.currency,
        )}*`;

        message += `\r\nValor do troco: *${formatCurrency(
          modalClientChange - cart.total,
          store?.currency,
        )}*`;
      }
    }

    CreateEvent(EVENT_TYPE.ORDER);

    SendOrder(cart.total, cart, 'whatsapp');

    cart.items.forEach(element => {
      CreateEvent(EVENT_TYPE.BUY_PRODUCT, element.id);
    });

    dispatch(reset());
    openUrl(`https://wa.me/${store.whatsapp}?text=${encodeURI(message)}`);
    toast.success('Pedido encaminhado para o WhatsApp! Bom apetite!', {
      position: 'top-center',
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      onClose: () => {
        navigation.goBack();
      },
    });
  };

  const isBrazil = store?.currency === 'R$';

  return (
    <Modal
      isOpen={clientModal}
      style={{
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.4)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        },
        content: {
          position: 'relative',
          inset: 'auto',
          border: 'none',
          background: 'none',
          padding: 0,
          width: '90%',
          maxWidth: '450px',
          overflow: 'visible',
        },
      }}>
      <ConfirmContainer>
        <CloseButton onPress={() => setClientModal(false)}>
          <CloseIcon fill="#000" style={{ height: 20 }} />
        </CloseButton>
        <InputTextContainer>
          <Label>Seu nome</Label>
          <InputText
            placeholder="Digite seu nome"
            name="name"
            defaultValue={cart.clientName}
            onChangeText={setModalClientName}
          />
        </InputTextContainer>
        <InputTextContainer>
          <GroupLabel>Endereço</GroupLabel>
          <SubLabel>Código postal</SubLabel>
          <InputText
            placeholder="Digite seu código postal"
            name="postalCode"
            defaultValue={cart.postalCode}
            onChangeText={setModalClientPostalCode}
          />
        </InputTextContainer>
        <InputTextContainer>
          <SubLabel>Endereço completo</SubLabel>
          <InputText
            placeholder="Digite seu endereço"
            name="address"
            defaultValue={cart.address}
            onChangeText={setModalClientAddress}
          />
        </InputTextContainer>
        <ToggleRow>
          <ToggleLabel>Deseja factura?</ToggleLabel>
          <Switch value={wantsInvoice} onValueChange={setWantsInvoice} />
        </ToggleRow>
        {wantsInvoice && (
          <InputTextContainer>
            <Label>{isBrazil ? 'CPF ou NIF' : 'NIF'}</Label>
            <InputText
              placeholder={
                isBrazil ? 'Digite seu CPF ou NIF' : 'Digite seu NIF'
              }
              name="document"
              defaultValue={cart.document}
              onChangeText={setModalClientDocument}
            />
          </InputTextContainer>
        )}
        {store.hasPayment && payment?.hasChange && (
          <InputTextContainer>
            <Label>Precisa de troco para quanto?</Label>
            <InputText
              placeholder={`Caso não precise, deixe em branco :)`}
              keyboardType="numeric"
              name="change"
              onChangeText={value => setModalClientChange(value * 100)}
            />
          </InputTextContainer>
        )}
        <CustomButton
          accessibilityRole="link"
          target="_blank"
          onPress={() => getOrderText()}>
          Confirmar Pedido
        </CustomButton>
      </ConfirmContainer>

    </Modal >
  );
};

export default Checkout;
